import React from 'react'
import Header from '../../../header'
import "./tools.css"
import Footer from '../../../footer'

function tools() {

    return (
        <div className="main-wrapper">
            <Header />
            <div style={{ marginTop: '5%' }}>
                {/* <Bannerpage /> */}
                {/*  */}
                <div className="inner-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="instructor-wrap border-bottom-0 m-0">
                                    <div className="about-instructor align-items-center"></div>
                                </div>
                                <h2>{"Journals Feed"}</h2>

                                <div
                                    className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 "
                                    style={{ justifyContent: "end" }}
                                >
                                    <div className="cou-info">
                                        <h2 style={{ textAlign: "center",color:"white"}}>
                                            Tools
                                        </h2 >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt-4">
                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://scholar.google.com/" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            1. Google Scholar
                        </a>
                    </h6>
                    <p>
                        Google Scholar is a freely accessible web search engine that indexes the full text or metadata of scholarly literature across an array of publishing formats and disciplines.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://arxiv.org/" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            2. arXiv
                        </a>
                    </h6>
                    <p>
                        arXiv is a repository of electronic preprints approved for publication after moderation, that consists of scientific papers in the fields of mathematics, physics, astronomy, electrical engineering, computer science, quantitative biology, statistics, and quantitative finance.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.eric.ed.gov/" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            3. ERIC
                        </a>
                    </h6>
                    <p>
                        U.S. Department of Education database of education-related literature, including journal articles, conferences, government documents, reports, books, and bibliographies.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.eric.ed.gov/" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            4. Hyper Articles en Ligne
                        </a>
                    </h6>
                    <p>
                        Hyper Articles en Ligne (HAL) is an open archive where authors can deposit scholarly documents from all academic fields.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://www.nlm.nih.gov/bsd/pmresources.html" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            5. MEDLINE
                        </a>
                    </h6>
                    <p style={{ whiteSpace: "pre-line" }}>
                        MEDLINE is a bibliographic database of life sciences and biomedical information.

                        Compiled by the United States National Library of Medicine (NLM), MEDLINE is freely available on the Internet and searchable via PubMed and NLM’s National Center for Biotechnology Information’s Entrez system.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://www.nlm.nih.gov/bsd/pmresources.html" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            6. ResearchGate
                        </a>
                    </h6>
                    <p>
                        ResearchGate is a social networking site for scientists and researchers to share papers, ask and answer questions, and find collaborators. According to a study by Nature and an article in Times Higher Education, it is the largest academic social network in terms of active users.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.thecochranelibrary.com/view/0/index.html" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            7. The Cochrane Library
                        </a>
                    </h6>
                    <p>
                        A collection of seven evidence-based medicine databases.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://www.scopus.com/home.uri" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            8. Scopus
                        </a>
                    </h6>
                    <p>
                        Scopus is the world’s largest abstract and citation database of peer-reviewed research literature.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="https://www.emeraldgrouppublishing.com/" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            9. Emerald Group Publishing
                        </a>
                    </h6>
                    <p>
                        Teaching cases, covering the fields of management, business, education, library studies, health care, and engineering.
                    </p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://apps.webofknowledge.com/WOS_GeneralSearch_input.do?product=WOS&&search_mode=GeneralSearch&&SID=" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            10. Web of Science
                        </a>
                    </h6>
                    <p>
                        Web of Science is an online subscription-based scientific citation indexing service originally produced by the Institute for Scientific Information (ISI).
                    </p>
                </div>
            </div>


            <div className=' container tools2'>
                <h1>Ethics in Research</h1>
                <p>The bases for human subject protection:</p>
                <ul>
                    <li><a href="http://apps.webofknowledge.com/WOS_GeneralSearch_input.do?product=WOS&&search_mode=GeneralSearch&&SID="  target="_blank" rel="noopener noreferrer">The Belmont Report</a></li>
                    <li><a href="https://ori.dhhs.gov/education/products/RCRintro/c03/b1c3.html" target="_blank" rel="noopener noreferrer">The Nuremberg Code</a></li>
                    <li><a href="http://www.wma.net/en/30publications/10policies/b3/" target="_blank" rel="noopener noreferrer"> World Medical Association Declaration of Helsinki</a></li>
                </ul>

                <div className="section">
                    <a href="http://grants.nih.gov/grants/policy/hs/index.htm" target="_blank" rel="noopener noreferrer">National Institutes of Health (NIH) Office of Extramural Research (OER), Research Involving Human Subjects</a>
                    <ul>
                        <li><a href="http://grants.nih.gov/grants/policy/hs/regulations.htm" target="_blank" rel="noopener noreferrer">Regulations, policies, and guidance</a></li>
                        <li><a href="http://grants.nih.gov/grants/policy/hs/populations.htm" target="_blank" rel="noopener noreferrer">Research with vulnerable populations</a></li>
                        <li><a href="http://grants.nih.gov/grants/policy/hs/training.htm" target="_blank" rel="noopener noreferrer">Human subjects protection training</a></li>
                        <li><a href="http://phrp.nihtraining.com/users/login.php" target="_blank" rel="noopener noreferrer">NIH Protecting Human Research Participants</a>, a free, online tutorial...</li>
                    </ul>
                </div>

                <div className="section">
                    <a href="https://www.hhs.gov/ohrp/" target="_blank" rel="noopener noreferrer">Health and Human Services (HHS) Office of Human Research Protections (OHRP)</a>
                    <ul>
                        <li><a href="https://www.hhs.gov/ohrp/humansubjects/index.html" target="_blank" rel="noopener noreferrer">Regulations</a></li>
                        <li><a href="https://www.hhs.gov/ohrp/policy/index.html" target="_blank" rel="noopener noreferrer">Policy and guidance</a> on informed consent, vulnerable populations, and more</li>
                        <li><a href="https://www.hhs.gov/ohrp/assurances/index.html" target="_blank" rel="noopener noreferrer">IRBs and assurances</a></li>
                        <li><a href="https://www.hhs.gov/ohrp/assurances/index.html" target="_blank" rel="noopener noreferrer">International Research Standards</a></li>
                        <li><a href="https://www.hhs.gov/ohrp/education/training/ded_video.html" target="_blank" rel="noopener noreferrer">Educational videos</a> and <a href='https://www.hhs.gov/ohrp/education/training/ded_webinar.html' target="_blank" rel="noopener noreferrer"> webinars</a></li>
                    </ul>
                </div>

                <div className="section">
                    <a href="https://ori.dhhs.gov/" target="_blank" rel="noopener noreferrer">Health and Human Services (HHS) Office of Research Integrity</a>
                    <p>HHS policies, regulations, information on research misconduct, conferences, publications, and more</p>
                </div>

                <div className="section">
                    <a href="http://www.fda.gov/oc/ohrt/irbs/" target="_blank" rel="noopener noreferrer">U.S. Food and Drug Administration (FDA) Guidance for Institutional Review Boards and Clinical Investigators</a>
                    <p>FDA &apos;s current thinking on protection of human subjects in research</p>
                </div>

                <div className="section">
                    <a href="http://www.who.int/ethics/research/en/" target="_blank" rel="noopener noreferrer">World Health Organization (WHO) Ethical standards and procedures for research with human beings</a>
                    <p>Guidelines, regional activities, and more</p>
                </div>

                <div className="section">
                    <a href="http://researchethicsblog.com/" target="_blank" rel="noopener noreferrer">Research Ethics Blog</a>
                    <p>Human Subjects Research Ethics blog</p>
                </div>

                <div className="section">
                    <a href="http://researchethicsblog.com/" target="_blank" rel="noopener noreferrer">blog.bioethics.net</a>
                    <p>The American Journal of Bioethics blog</p>
                </div>
            </div>


            <div className="container mt-4">
                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.nap.edu/openbook.php?record_id=4917" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            On Being A Scientist: Responsible Conduct In Research
                        </a>
                    </h6>
                    <p>eBook from the National Academies Press</p>
                </div>

                <h5>Statistical Tools</h5>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.statsoft.com/textbook/stathome.html" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            Electronic Statistics Textbook
                        </a>
                    </h6>
                    <p>Electronic textbook providing both basic and in-depth exploration of statistical concepts</p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://statpages.org/javasta6.html" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            The Interactive Statistical Pages
                        </a>
                    </h6>
                    <p>Provides links to online books, tutorials, and software, as well as downloadable software</p>
                </div>

                <div className="mb-3">
                    <h6 style={{ color: "blue", textDecoration: "underline" }}>
                        <a href="http://www.amstat.org/about/ethicalguidelines.cfm" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "none" }}>
                            ASA’s Ethical Guidelines for Statistical Practice
                        </a>
                    </h6>
                    <p>
                        Intended to encourage ethical and effective statistical work, and to assist students in learning to perform statistical work responsibly
                    </p>
                </div>

                <div className="mb-3">
                    <a href="http://www.asha.org/uploadedFiles/ASHA/Research/CPRI/2012-CPRI-Dollaghan-Studies-of-Diagnosis-and-Screening.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Studies of Diagnosis and Screening [PDF]
                    </a>
                    <span>, CPRI 2012</span>
                </div>

                <div className="mb-3">
                    <a href="http://ktclearinghouse.ca/cebm/toolbox"  target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        EBM toolbox</a>, <a  href='http://ktclearinghouse.ca/cebm' target="_blank" rel="noopener noreferrer"  style={{ color: "blue", textDecoration: "underline" }}>Centre for Evidence Based Medicine
                    </a>
                    <span>, Toronto</span>
                </div>

                <div className="mb-3">
                    <a href="http://www.cebm.net/index.aspx?o=1023" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Oxford Centre for Evidence Based Medicine
                    </a>
                </div>

                <div className="mb-3">
                    <p>University of British Columbia Bayesian calculator</p>
                </div>

                <div className="mb-3">
                    <a href="http://www.hrc.es/investigacion/metadisc_en.htm"   target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Meta-DisC Software
                    </a>
                    <span>, Hospital Universitario Ramon y Cajal</span>
                </div>

                <div className="mb-3">
                    <a href="http://www.asha.org/uploadedFiles/ASHA/Research/CPRI/2011-CPRI-Presentation-Optimizing-Clinical-Research.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Optimizing Clinical Research for Evidence-Based Practitioners [PDF]
                    </a>
                    <span>, CPRI 2011</span>
                </div>

                <div className="mb-3">
                    <a href="http://www.asha.org/uploadedFiles/ASHA/Research/CPRI/2009-CPRI-Presentation-Group-Studies-Treatment.pdf"  target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Group Studies of Treatment [PDF]
                    </a>
                    <span>, CPRI 2009</span>
                </div>

                <div className="mb-3">
                    <p>
                        <a href='http://www.latrobe.edu.au/psy/research/projects/esci' target="_blank" rel="noopener noreferrer">Exploratory Software for Confidence Intervals</a>, Geoff Cumming, Latrobe University
                    </p>
                </div>

                <div className="mb-3">
                    <p>
                        <a href='https://dl.dropbox.com/u/1857674/CIstuff/CI.html'  target="_blank" rel="noopener noreferrer" >Scripts and Software for Noncentral Confidence Interval and Power Calculations</a>, Mike Smithson, Australian National University
                    </p>
                </div>

                <div className="mb-3">
                    <p>
                        PSY Statistical Program, School of Psychology, the University of New South Wales
                    </p>
                </div>

                <div className="mb-3">
                    <a href="http://www.asha.org/uploadedFiles/ASHA/Research/CPRI/2009-CPRI-Presentation-Single-Subject-Research.pdf"  target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Issues in Single-Subject Research [PDF]
                    </a>
                    <span>, by Kevin Kearns, CPRI 2009</span>
                </div>

                <div className="mb-3">
                    <a href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC2366174/?tool=pmcentrez"  target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Evaluating Single-Subject Treatment Research: Lessons Learned from the Aphasia Literature
                    </a>
                    <p>
                        by Pélagie M. Beeson and Randall R. Robey <br />
                        Article on calculating effect sizes for single-subject designs
                    </p>
                </div>

                <div className="mb-3">
                    <a href="http://www.clinicalresearcher.org/software.htm"  target="_blank" rel="noopener noreferrer" style={{ color: "blue", textDecoration: "underline" }}>
                        Simulation Modeling Analysis program
                    </a>
                    <span> on ClinicalResearch.org</span>
                    <p>
                        Bootstrapping techniques for statistical significance testing for single-subject designs
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default tools